import React from 'react';
import cn from 'classnames';
import './BookListBlock.scss';
import BookTile from '~/components/book-tile/book-tile-display';
export function BookListBlock({ data }) {
    return (React.createElement("div", { className: cn('content-block-book-list') }, data.value.books.map((book) => React.createElement(BookTile, { key: book.id, book: book }))));
}
